import React, { PropTypes } from 'react';

/**
 * Activity Feed Number For List Item
 */
const ItemNumber = (props) => {
  const { number, prefix, type, onClick, deleted, suffix, possessive } = props;

  const possessiveSuffix = possessive ? "'s" : '';

  const numberNode = deleted ? (
    <span>
      <span className="af-list-item-deleted">(DELETED)</span>
    </span>
  ) : (
    <a onClick={onClick}>{number}</a>
  );

  const prefixNode = prefix ? (
    <span className="af-list-item-number-prefix">{prefix}</span>
  ) : null;

  const suffixNode = suffix ? (
    <span className="af-list-item-number-suffix">{suffix}</span>
  ) : null;

  return (
    <div className="af-list-item-number">
      {prefixNode}
      <span className="af-list-item-number-value">
        <span>{type}</span>&nbsp;{numberNode}
        <span>{possessiveSuffix}</span>
      </span>
      {suffixNode}
    </div>
  );
};

ItemNumber.propTypes = {
  onClick: PropTypes.func,
  deleted: PropTypes.bool,
  type: PropTypes.string,
  possessive: PropTypes.bool,
  prefix: PropTypes.string,
  suffix: PropTypes.string,
  number: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default ItemNumber;
